import Vue from 'vue'

const saveToLocalStorage = (storageName, state) => {
  localStorage[storageName] = JSON.stringify(state)
  if (Vue.getEnvironmentName() === 'development') {
    // eslint-disable-next-line no-console
    console.log(`Local Storage ${storageName}:`, localStorage[storageName])
  }
}

const getFromLocalStorage = (storageName) => {
  let retrievedState
  try {
    retrievedState = localStorage.getItem(storageName)
    retrievedState = JSON.parse(retrievedState)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e)
  }
  return retrievedState
}
const persistance = {
  saveToLocalStorage,
  getFromLocalStorage
}

Vue.helpers = Vue.prototype.$helpers = {
  ...Vue.helpers,
  ...persistance
}

export default persistance
